import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz22 = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel23'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel21'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Maximum Chocolates</h1>
    
    <div class="text">
        <p>You have 15 Rs with you. You go to a shop and shopkeeper tells you price as 1 Rs per chocolate. He also tells
            you that you can get a chocolate in return of 3 wrappers. How many maximum chocolates you can eat?</p>
        <p>&nbsp;<br/>
            &nbsp;<br/>
            &nbsp;<br/>
            &nbsp;<br/>
            &nbsp;</p>
        <div class="containers">
        <p>Answer: 22<br/>
            Buy and eat <strong>15</strong> chocolates<br/>
            Return 15 wrappers and get <strong>5</strong>
            more chocolates.<br/>
            Return 3 wrappers, get <strong>1 </strong>chocolate and eat it (keep 2 wrappers)<br/>
            Now
            we have 3 wrappers. Return 3 and get <strong>1 </strong>more chocolate.</p>
        <p>So total chocolates = 15 + 5 + 1 + 1</p>
       </div>
    </div>
</article>
        </div>
    )
}

export default Puz22
